export default __webpack_public_path__ + "static/media/worker.e9d3f71e.png";